import { registerRenderer } from "../registry.js";
import { renderServiceBookingBlock } from "./service-booking-renderer.js";

registerRenderer("calendar-embed", {
  render(props, ctx) {
    return renderServiceBookingBlock(props, ctx, "Book Your Appointment");
  },
});
